import { useCallback } from 'react';

import useMediaBreakpoints from 'hooks/useMediaBreakpoints';

export const getUserName = (user) => {
  return [user.firstName, user.lastName].filter(Boolean).join(' ') || 'Guest';
};

export const setGPViewed = (id) => {
  localStorage.setItem(`GP_${id}_VIEWED`, 'true');
};

export const getGPViewed = (id) => localStorage.getItem(`GP_${id}_VIEWED`);

export const clearGPViewed = (id) => {
  localStorage.removeItem(`GP_${id}_VIEWED`);
};

export const useGetPrimaryImageUrl = (itinerary = {}) => {
  const { isTabletOrMobile, isMobile, isBigScreenMinWidth } = useMediaBreakpoints();

  const getPrimaryImageUrl = useCallback(
    (itinerary) => {
      if (isBigScreenMinWidth && itinerary?.primaryImageVersion1600) {
        return itinerary.primaryImageVersion1600;
      }
      if (!isBigScreenMinWidth && !isTabletOrMobile && itinerary?.primaryImageVersion1200) {
        return itinerary.primaryImageVersion1200;
      }
      if (isMobile && itinerary?.primaryImageVersion400) {
        return itinerary.primaryImageVersion400;
      }
      if (isTabletOrMobile && itinerary?.primaryImageVersion800) {
        return itinerary.primaryImageVersion800;
      }
      return itinerary?.primaryImageUrl;
    },
    [isBigScreenMinWidth, isMobile, isTabletOrMobile],
  );

  const primaryUrl = getPrimaryImageUrl(itinerary);

  return { primaryUrl };
};
